import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import CarTagView from "../../../../../components/CarTag";
import CarTimerIcon from "../../../../../../media/images/icons/car-timer";
import profileImage from "../../../../../../media/images/profileImage.svg";
import { useAppSelector } from "../../../../../../hooks/useRedux";

export default function UserInfo() {
  const theme = useTheme();

  const { fullName } = useAppSelector((state) => state.user);

  return (
    <Box
      sx={{
        borderRadius: "8px",
        display: "flex",
        padding: "4px 8px",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "bgColor.white",
        boxShadow: "2px 2px 4px 2px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <img
          style={{
            width: "32px",
            borderRadius: "50%",
          }}
          src={profileImage}
          alt=""
        />
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: "14px",
          }}
          noWrap
        >
          {fullName}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <CarTagView />

        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "10px",
            borderRadius: "8px",
            gap: "4px",
            boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2) inset",
          }}
        >
          <CarTimerIcon size={22} color={theme.palette.textColor.main} />

          <Typography
            sx={{
              fontSize: "10px",
              fontWeight: "700",
            }}
            noWrap
          >
            بار فعالی ندارید
          </Typography>
        </Box> */}
      </Box>
    </Box>
  );
}
